import { Avatar, Image } from '@zillow/constellation';
import React from 'react';

import type { AuthorAvatarProps } from './AuthorPage.types';

/**
 * Displays the author's avatar image or initials.
 */
const AuthorAvatar: React.FC<AuthorAvatarProps> = ({ avatar, name, size }) => {
    if (!avatar) return null;

    return (
        <Avatar size={size} marginBottom="sm">
            <Image src={avatar} alt={name} />
        </Avatar>
    );
};

export default AuthorAvatar;
